export default class RetailItemComm {
    getProductData(id, type) {
        const headers = new Headers({
            'Accept': 'application/vnd.ikea.iows+json;version=2.0',
            'Contract': window.Checkout.settings.shoppinglist.itemComm.adapter.contract,
            'Consumer': window.Checkout.settings.shoppinglist.itemComm.adapter.consumer,
            'Cache-Control': 'no-cache, no-store',
        });

        const init = {
            method: 'GET',
            headers: headers,
            mode: 'cors',
        };

        const request = new Request(window.Checkout.settings.shoppinglist.itemComm.adapter.endpoint + '/retail/iows/' + window.Checkout.settings.locale_url + '/catalog/items/' + type + ',' + id, init);

        return fetch(request);
    }
}
